/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryAdjustments = sqliteTable('inventory_adjustments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  adjustment_number: text('adjustment_number'),
  adjustment_date: text('adjustment_date'),
  location: text('location'),
  remarks: text('remarks'),
  status: text('status'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
